export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8822.26e055e8.jpg";